<template>
  <PopupContent :bodyClass="['premium-popup-body']">
    <template #header>
      <h2>{{ $t('premiumPurchase.bmc.title') }}</h2>
    </template>

    <p class="subtitle">{{ $t('premiumPurchase.bmc.subtitle') }}</p>

    <div class="status-container">
      <div v-if="purchase.state.isWaitingForConfirmation" class="waiting-state">
        <div class="spinner"></div>
        <p>{{ $t('premiumPurchase.bmc.waiting') }}</p>
      </div>

      <div v-if="purchase.state.successMessage" class="success-message">
        {{ purchase.state.successMessage }}
      </div>

      <div v-if="purchase.state.errorMessage" class="error-message">
        {{ purchase.state.errorMessage }}
      </div>
    </div>

    <template #footer>
      <div class="modal-actions">
        <button v-if="purchase.state.isWaitingForConfirmation" class="cancel-button" @click="viewModel.handleCancel()">
          {{ $t('common.cancel') }}
        </button>
        <button v-else class="close-button" @click="viewModel.handleClose()">
          {{ $t('common.close') }}
        </button>
      </div>
    </template>
  </PopupContent>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { BuyMeCoffeePopupViewModel } from '../../../popup-view-models/buyme-coffee-popup.view-model';
import PopupContent from '../../../components/PopupContent.vue';

const props = defineProps<{
  viewModel: BuyMeCoffeePopupViewModel;
}>();

const purchase = computed(() => props.viewModel.purchase);
</script>

<style scoped>
.premium-popup-body {
  padding: 0;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  color: #333;
}

h2 {
  color: #333;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
}

.subtitle {
  color: #666;
  margin-bottom: 2rem;
}

.status-container {
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
}

.waiting-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(102, 126, 234, 0.3);
  border-top-color: #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.error-message {
  background: #fee;
  color: #c33;
  padding: 12px;
  border-radius: 8px;
  width: 100%;
}

.success-message {
  background: #efe;
  color: #3c3;
  padding: 12px;
  border-radius: 8px;
  width: 100%;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.cancel-button, .close-button {
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
  background: #f0f0f0;
  color: #333;
}

.cancel-button:hover, .close-button:hover {
  background: #e0e0e0;
}
</style>
